<script setup>
/**
 * 应用外壳：只做两件事 —— 选布局、驱动数据轮询。
 *
 * 轮询放在外壳而不是布局里：诊断页走 BlankLayout，同样需要实时数据，
 * 放进 ConsoleLayout 会导致切到诊断页就断流。
 */
import { computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useConsoleStore } from '@/stores/console'
import { useRiskStore } from '@/stores/risk'
import ConsoleLayout from '@/layouts/ConsoleLayout.vue'
import BlankLayout from '@/layouts/BlankLayout.vue'
import GlossaryTip from '@/components/GlossaryTip.vue'

const route = useRoute()
const c = useConsoleStore()
const risk = useRiskStore()

const layout = computed(() => (route.meta.layout === 'blank' ? BlankLayout : ConsoleLayout))

/* 每次快照更新后重算风控状态。
 *
 * 计划的基准化原来也挂在这里（前端按首帧实时价算一次档位）。
 * 现在计划由后端每日生成并随快照下发，前端不再参与 —— 少了一处
 * "同一份计划在不同浏览器里长得不一样"的来源。 */
watch(() => c.lastAt, () => risk.evaluate())

onMounted(() => c.start(2000))
onBeforeUnmount(() => c.stop())
</script>

<template>
  <component :is="layout">
    <RouterView />
  </component>
  <!-- 术语浮层：全应用唯一一个实例，靠事件委托响应所有 .gloss 节点。
       放在外壳而不是布局里，诊断页（BlankLayout）同样要有解释。 -->
  <GlossaryTip />
</template>
